import React from 'react';
import './image-failure.css';
import { ReactComponent as Problem } from './problem.svg';

const ImageFailure = () => {
  return (
    <div className="image-fallback">
      <Problem /> Image has failed to load
    </div>
  );
};

export default ImageFailure;
